import React, { useEffect } from 'react'
import { relativeUrlOf, rememberDeepLink } from './utils/DeepLink'
import RequiredAuthLayout from 'RequiredAuthLayout'
import { useAuthService } from './api/AuthServiceConfig'
import { useNavigate } from 'react-router-dom'
import * as paths from './utils/Links'
import './assets/styles/global.scss'
import './_app.scss'

export const RequiredAuth: React.FC = () => {
  const { authState } = useAuthService()
  const navigate = useNavigate()

  useEffect(() => {
    // 'unknown' means the session is still being restored — a reload arrives with no access token but often
    // a live fluro_refresh cookie, so bouncing on anything short of a settled 'unauthenticated' would sign
    // customers out on every refresh of the page.
    if (authState.status === 'unauthenticated') {
      rememberDeepLink(relativeUrlOf(window.location.href, window.location.origin))
      navigate(paths.getSignIn())
    }
  }, [authState.status, navigate])

  return authState.status === 'authenticated' ? <RequiredAuthLayout /> : <div>Loading...</div>
}
